"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var filterTableData = function (data, columns, filters, customFilters) {
    var _a;
    if (columns.some(function (column) { return column.filter; }) && Object.keys(filters).length === 0) {
        return [];
    }
    var result = __spreadArray([], __read(data), false);
    // custom filters
    if (((_a = customFilters === null || customFilters === void 0 ? void 0 : customFilters.length) !== null && _a !== void 0 ? _a : 0) > 0) {
        customFilters === null || customFilters === void 0 ? void 0 : customFilters.forEach(function (filterFunction) {
            result = result.filter(filterFunction);
        });
    }
    // column filters
    return Object.keys(filters).reduce(function (filteredData, columnId) {
        var column = columns.find(function (c) { return c.id === columnId; });
        if (column) {
            return filteredData.filter(function (item) {
                var dataValues = filters[columnId];
                return dataValues.includes(column.accessor(item));
            });
        }
        return filteredData;
    }, result);
};
exports.default = filterTableData;
